import find from "lodash/find";
import deleteNodeRecursively from "./deleteNodeRecursively";

export default (model, targetBranchFirstNodeId) => {
  const firstNode = find(model.nodes, { id: targetBranchFirstNodeId });
  deleteNodeRecursively(model, firstNode.id, firstNode.before[0]);
  return model;
};
